import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: '家づくりの基礎', href: '#content' },
    { label: '資金・ローン', href: '#content' },
    { label: '物件の選び方', href: '#content' },
    { label: 'このサイトについて', href: '#about' },
    { label: '運営者について', href: '/profile' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-sm border-b border-[#E8DDD0]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2.5 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/2c450daa-ab1c-4449-ac53-d1ae0dbc5040.png"
            alt="はじめての家づくりガイド ロゴ"
            className="h-8 w-auto object-contain"
          />
          <span
            className={`text-sm font-semibold whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-[#2C2C2C]' : 'text-white'
            }`}
          >
            鳥取ではじめての家づくり
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((link) =>
            link.href.startsWith('/') ? (
              <Link
                key={link.label}
                to={link.href}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'text-[#6B6B6B] hover:text-[#8FA882]'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'text-[#6B6B6B] hover:text-[#8FA882]'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            )
          )}
          <a
            href="#cta"
            className="text-sm font-semibold px-5 py-2 rounded-full bg-[#8FA882] text-white hover:bg-[#7A9570] transition-colors duration-200 whitespace-nowrap cursor-pointer max-w-xs text-center leading-snug"
          >
            最初に読むべき記事はこちら
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            scrolled ? 'text-[#2C2C2C]' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニューを開く"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} />
        </button>
      </div>

      {/* Mobile Drawer */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#E8DDD0] px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) =>
            link.href.startsWith('/') ? (
              <Link
                key={link.label}
                to={link.href}
                className="text-sm font-medium text-[#6B6B6B] hover:text-[#8FA882] transition-colors cursor-pointer"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                className="text-sm font-medium text-[#6B6B6B] hover:text-[#8FA882] transition-colors cursor-pointer"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            )
          )}
          <a
            href="#cta"
            className="text-sm font-semibold px-5 py-2.5 rounded-full bg-[#8FA882] text-white text-center hover:bg-[#7A9570] transition-colors cursor-pointer leading-snug"
            onClick={() => setMenuOpen(false)}
          >
            家づくりの全体像が５分でわかる<br />｜最初に読むべき記事はこちら
          </a>
        </div>
      )}
    </nav>
  );
}
